import React from "react";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import { cloneDeep } from "lodash";

function MultiBooleanSetting({ setting, setParentState, styles = {}, formControlStyle = {} }) {
  // const switchProps = {
  //   checked: !!setting.field_value,
  //   onChange: (e) => {
  //     setParentState(Number(e.target.checked));
  //   },
  // };

  const handleOnChange = (value, index) => {
    const newValues = cloneDeep(setting.field_value);
    newValues[index].value = value;

    setParentState([...newValues]);
  };

  return (
    <Box sx={{ marginBottom: "2rem", ...styles }}>
      {setting?.field_value?.map?.(({ value, display }, i) => (
        <FormControl component="fieldset">
          <FormGroup aria-label="position" row>
            <FormControlLabel
              value="start"
              control={
                <Switch
                  defaultChecked={!!value}
                  onChange={(e) => handleOnChange(e.target.checked, i)}
                />
              }
              label={display || ""}
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                paddingLeft: ".5rem",
                ...formControlStyle,
              }}
            />
          </FormGroup>
        </FormControl>
      ))}
    </Box>
  );
}

export default MultiBooleanSetting;
